/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2016, Zumper
 */

export const BREAKPOINT_1240 = 1240

export const BREAKPOINT_1140 = 1140

export const BREAKPOINT_1024 = 1024

export const BREAKPOINT_1020 = 1020

export const BREAKPOINT_950 = 950

// width in pixels for mobile view
export const MAX_MOBILE_WIDTH = 767
